<script lang="ts">
	import Moon from '$lib/icons/moon.svelte';
	import SunFilled from '$lib/icons/sun-filled.svelte';
	import { cn } from '$utils/cn';
	import { mode, toggleMode } from 'mode-watcher';
	import Button from './button.svelte';

	const { class: className = '', showCurrentOnly }: { class?: string; showCurrentOnly?: boolean } =
		$props();
</script>

<Button
	variant="outline"
	class={cn(
		'border-border bg-background hover:bg-background-soft dark:border-border mb-4 flex h-8 cursor-pointer items-center justify-center rounded-full p-1 md:mb-0',
		className
	)}
	onclick={toggleMode}
>
	<div
		class="text-primary relative inline-flex h-full w-full flex-row items-center justify-center gap-2"
	>
		{#if showCurrentOnly}
			{#if mode.current === 'dark'}
				<SunFilled class="size-4" />
			{:else}
				<Moon class="size-4" />
			{/if}
		{:else}
			<div
				class="bg-border absolute left-0 -z-10 my-auto size-5 rounded-full transition-transform duration-300 ease-in-out"
				style="transform: {mode.current == 'light' ? 'translateX(0)' : 'translateX(1.5rem)'}"
			></div>
			<Moon class="ml-0.5 size-4" />
			<SunFilled class="mr-0.5 size-4" />
		{/if}
	</div>
</Button>
